import Colors from "./Colors";
import Images from "./Images";
import ServiceIcons from "./ServiceIcons";

export { Colors, Images, ServiceIcons };



// WEBPACK FOOTER //
// ./src/Themes/index.ts